import {UrlObj} from "./other/UrlObj";
import {ServerService} from "../services/server.service";
import {Injectable} from "@angular/core";
import {DataService} from "../services/data.service";
import {ActivatedRoute} from "@angular/router";

@Injectable({
   providedIn: 'root'
})
export class BrandFactory {

   constructor(private serverSrv: ServerService,
               private dataSrv: DataService,
               private route: ActivatedRoute) {

   }

   async getBrands(value=undefined, vendorSlug=null):Promise<Brand[]> {
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/brands` : `/api/brands`
      return new Promise((resolve, reject) => {
         ServerService.instance.getAll(Brand, url, {value:value}).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async postBrand(data, vendorSlug=null):Promise<Brand> {
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/brands` : `/api/brands`
      return new Promise((resolve, reject) => {
         ServerService.instance.post( url, data, Brand).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async putBrand(brandId, data, vendorSlug):Promise<Brand[]> {
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/brands/${brandId}` : `/api/brands/${brandId}`
      console.log(url)
      return new Promise((resolve, reject) => {
         ServerService.instance.put( url, data, Brand).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async cambiaStatoApprovazione(brandId) {
      return new Promise((resolve, reject) => {
         ServerService.instance.put( `/api/brands/${brandId}/approva`, {}, Brand).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async deleteBrand(brandId):Promise<Brand[]> {
      return new Promise((resolve, reject) => {
         ServerService.instance.delete( `/api/brands/${brandId}`, {}, Brand).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

}

export class BrandData {
   id?: number;
   nome?: string;
}

export class Brand {

   data:BrandData = {}

   constructor(data:BrandData) {
      // assegno al mio oggetto data (è un json)
      if(!data) data = {}
      Object.assign(this.data, data)
   }

   public static BASE_URL(path=null, vendorSlug, queryParams={}):string{
      let url = vendorSlug ?
         `/api/esercizi/${vendorSlug}/brands`
         : `/api/brands`
      let urlObj:UrlObj = new UrlObj(url, queryParams);
      if(path) urlObj.url += path;
      return urlObj.toString()
   }

}
